import { Modal, Alert } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import { hideSessionWarning, showSessionTimeout } from '../../slices/authSlice';
import { proactiveRefresh } from '../../services/apiService';

const SessionWarningModal = () => {
  const dispatch = useDispatch();
  const { showSessionWarningModal, tokenExpiresAt, loginTimestamp } = useSelector((state) => state.auth);
  const [secondsLeft, setSecondsLeft] = useState(600);
  const [extending, setExtending] = useState(false);

  useEffect(() => {
    if (!showSessionWarningModal) return;
    const expiresAt = tokenExpiresAt || (loginTimestamp ? loginTimestamp + 3 * 60 * 60 * 1000 : null);
    if (!expiresAt) return;

    const updateCountdown = () => {
      const remaining = Math.max(0, expiresAt - Date.now());
      setSecondsLeft(Math.floor(remaining / 1000));
      if (remaining <= 0) {
        dispatch(hideSessionWarning());
        dispatch(showSessionTimeout());
      }
    };

    updateCountdown();
    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, [showSessionWarningModal, tokenExpiresAt, loginTimestamp, dispatch]);

  const handleExtend = async () => {
    setExtending(true);
    const ok = await proactiveRefresh();
    setExtending(false);
    if (ok) {
      dispatch(hideSessionWarning());
    } else {
      dispatch(hideSessionWarning());
      dispatch(showSessionTimeout());
    }
  };

  const handleLogout = () => {
    dispatch(hideSessionWarning());
    dispatch(showSessionTimeout());
  };

  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;

  return (
    <Modal
      title={
        <span style={{ color: '#262626', fontWeight: 600 }}>
          <ClockCircleOutlined style={{ marginRight: 8, color: '#faad14' }} />
          Session Expiring Soon
        </span>
      }
      open={showSessionWarningModal}
      onOk={handleExtend}
      onCancel={handleLogout}
      closable={false}
      maskClosable={false}
      centered
      okText={extending ? 'Extending...' : 'Stay Logged In'}
      cancelText="Log Out"
      okButtonProps={{ loading: extending, type: 'primary' }}
    >
      <div style={{ padding: '8px 0' }}>
        <p style={{ fontSize: '14px', marginBottom: '16px' }}>
          Your session will expire in{' '}
          <strong>{minutes}:{String(seconds).padStart(2, '0')}</strong>.
          Click "Stay Logged In" to continue working.
        </p>
        <Alert
          message="Unsaved work may be lost if the session expires"
          type="warning"
          showIcon
          style={{ marginBottom: '12px' }}
        />
        <p style={{ fontSize: '12px', color: '#666' }}>
          If you do nothing, you will be logged out when the session expires.
        </p>
      </div>
    </Modal>
  );
};

export default SessionWarningModal;
